import React from "react";
import ChartArea from "./ChartArea";
import OverviewContent from "./OverviewContent";
import { TimeframeOption } from "@constants/types";

type MarkerPoint = any;

// Main component - only structure, delegates rendering to optimized child components
const OverviewV2 = React.memo(
  (props: {
    data: any;
    chartData?: any;
    markerPoints?: MarkerPoint[];
    showTimeframeSelector?: boolean;
    onTimeframeChange?: (timeframe: TimeframeOption) => void;
    tokenType: "agETH" | "hgETH" | "sbUSD";
    aprTooltip?: string;
    activeTimeframe?: TimeframeOption;
  }) => {
    const {
      data: TEXT_STRINGS,
      chartData,
      markerPoints = [],
      showTimeframeSelector,
      onTimeframeChange,
      tokenType,
      aprTooltip,
      activeTimeframe,
    } = props;

    return (
      <div className="m-0">
        {/* Vertical layout: chart at top (full width), content below */}
        <div className="flex flex-col gap-0 pt-2">
          {/* Chart - Full Width */}
          <div className="w-full">
            <ChartArea
              chartData={chartData}
              markerPoints={markerPoints}
              showTimeframeSelector={showTimeframeSelector}
              onTimeframeChange={onTimeframeChange}
              tokenType={tokenType}
              aprTooltip={aprTooltip}
              activeTimeframe={activeTimeframe}
            />
          </div>

          {/* Overview Content - Full Width */}
          <div className="w-full pb-4 sm:pb-4px-1 tablet:px-1">
            <OverviewContent
              TEXT_STRINGS={TEXT_STRINGS}
              tokenType={tokenType}
            />
          </div>
        </div>
      </div>
    );
  }
);

OverviewV2.displayName = "OverviewV2";

export default OverviewV2;
